<template>
    <div class="document-finder">
        <results-panel ref="resultsPanel" class="results-panel"
                       :rows="resultsRows" :total-documents="totalDocuments"
                       :total-pages="totalPages" :current-page="currentPage"
                       @goToPage="goToPage" :project-id="projectId" @refreshResults="refreshResults"
                       :row-counter-base="rowCounterBase" :search-form-data="lastFormData"
                       :loading-documents="loadingDocuments"
                       :error-loading-documents="errorLoadingDocuments"
                       :showing-documents="showingDocuments"
                       :showing-empty-indicator="showingEmptyIndicator"
                       @changePageSize="changePageSize"
                       @refreshSilently="refreshSilently"
        ></results-panel>
    </div>
</template>

<script>
    // @ is an alias to /src
    import ResultsPanel from "@/components/ResultsPanel";
    import {searchDocuments} from "@/apis";

    export default {
        name: 'DocumentFinder',
        components: {
            ResultsPanel,
        },
        props: {
            projectId: String,
        },
        methods: {
            changePageSize(pageSize) {
                this.resultsCountPerPage = +pageSize;
                this.goToPage(0, true);
            },
            doSearch(pips) {
                const formData = {project_id: this.projectId};

                if (pips) {
                  formData['pips'] = pips.pips;
                  formData['involvedJoinedEventObjects'] = pips.involvedJoinedEventObjects;
                }

                this.currentPage = 0;
                this.lastFormData = formData;

                this.searchAndRenderDocuments(formData, 0, this.resultsCountPerPage)
            },
            goToPage(page, force) {
                if (this.currentPage === page && !force) {
                    return;
                }

                this.currentPage = page;

                this.searchAndRenderDocuments(this.lastFormData, page * this.resultsCountPerPage, this.resultsCountPerPage)
            },
            resultsFinishedUpdate() {
                this.$refs.resultsPanel.focus();
                this.$refs.resultsPanel.scrollResultsTableContainerToInitial();
            },
            refreshResults() {
                this.searchAndRenderDocuments(this.lastFormData, this.currentPage * this.resultsCountPerPage, this.resultsCountPerPage)
            },
            searchAndRenderDocuments(formData, start, size) {
                const searchRequestId = ++this.searchRequestId;

                this.setStates(true, false, false, false);

                searchDocuments(JSON.stringify(formData), start, size).then(r => {
                    if (searchRequestId !== this.searchRequestId) {
                        return;
                    }

                    this.resultsRows = r.data;
                    this.totalDocuments = r.total;

                    if (this.totalDocuments) {
                        this.setStates(false, false, true, false);
                    } else {
                        this.setStates(false, false, false, true);
                    }

                    this.$nextTick(() => {
                        this.resultsFinishedUpdate()
                    })
                }).catch((err) => {
                    if (searchRequestId !== this.searchRequestId) {
                        return;
                    }

                    this.setStates(false, true, false, false);
                    this.handleServerSideError(err);
                })
            },
            setStates(loadingDocuments, errorLoadingDocuments, showingDocuments, showingEmptyIndicator) {
                this.loadingDocuments = loadingDocuments;
                this.errorLoadingDocuments = errorLoadingDocuments;
                this.showingDocuments = showingDocuments;
                this.showingEmptyIndicator = showingEmptyIndicator;
            },
            refreshSilently() {
                if (this.loadingDocuments) {
                    return;
                }

                const formData = this.lastFormData;
                const start = this.currentPage * this.resultsCountPerPage;
                const size = this.resultsCountPerPage;

                const searchRequestId = ++this.searchRequestId;

                searchDocuments(JSON.stringify(formData), start, size).then(r => {
                    if (searchRequestId !== this.searchRequestId) {
                        return;
                    }

                    this.resultsRows = r.data;
                    this.totalDocuments = r.total;

                    if (this.totalDocuments) {
                        this.setStates(false, false, true, false);
                    } else {
                        this.setStates(false, false, false, true);
                    }

                }).catch(() => {

                })
            }
        },
        data () {
            return {
                resultsRows: [],
                totalDocuments: 0,
                currentPage: 0,
                lastFormData: null,
                searchRequestId: 0,
                loadingDocuments: false,
                errorLoadingDocuments: false,
                showingDocuments: false,
                showingEmptyIndicator: false,
                doSearchListener: null,
                resultsCountPerPage: 25,
            }
        },
        computed: {
            totalPages() {
                return Math.ceil(this.totalDocuments / this.resultsCountPerPage)
            },
            rowCounterBase() {
                return this.currentPage * this.resultsCountPerPage;
            }
        },
        mounted() {
            // this.doSearch();
            this.doSearchListener = (pips) => {
                this.doSearch(pips);
            }
            this.eventHub.$on(`searchDocumentsForProject${this.projectId}`, this.doSearchListener);
        },
        watch: {
            $route(to) {
                if (to.params.pid !== this.projectId) {
                    return;
                }
                if (to.name === 'document_finder') {
                    this.refreshSilently();
                }
            }
        },
        destroyed() {
            this.eventHub.$off(`searchDocumentsForProject${this.projectId}`, this.doSearchListener);
        }
    }
</script>

<style lang="scss" scoped>
    @import "../assets/variables";

    .document-finder {
        height: 100%;
    }

    .results-panel {
        height: 100%;
    }
</style>
